import React from 'react';

type TitleProps = {
  title: string;
  hidden?: boolean;
  className?: string;
  headingLevel?: 1 | 2 | 3 | 4;
  itemProp?: string;
};

const PageTitle = ({ title, hidden = false, headingLevel = 1, itemProp }: TitleProps) => {
  const classNames = hidden ? 'sr-only' : 'text-center text-3xl font-bold text-gray-800';
  switch (headingLevel) {
    case 1:
      return (
        <h1 className={classNames} itemProp={itemProp}>
          {title}
        </h1>
      );
    case 2:
      return (
        <h2 className={classNames} itemProp={itemProp}>
          {title}
        </h2>
      );
    case 3:
      return (
        <h3 className={classNames} itemProp={itemProp}>
          {title}
        </h3>
      );
    case 4:
      return (
        <h4 className={classNames} itemProp={itemProp}>
          {title}
        </h4>
      );
    default:
      return null;
  }
};

export default PageTitle;
